<template>
  <van-list v-if ="dataList && dataList.length >0" :finished="finished" :finished-text="finishedText" :immediate-check="false">
    <van-cell v-for="(item,index) in dataList" :key="index" :border="false">
      <template #default>
        <slot name="row" :row="item"></slot>
      </template>
    </van-cell>
  </van-list>
  <van-empty v-else description="暂无数据" />
</template>

<script>
import { PageMixin } from '@/mixins/PageMixin'
export default {
  name: 'NoPageList',
  props: {
    requestUrl: String,
    getParams: {
      type: Function,
      default: null
    }
  },
  mixins: [PageMixin],
  data () {
    return {
      url: {
        list: this.requestUrl
      }
    }
  },
  methods: {
    getQueryParams () {
      const params = Object.assign(this.queryParams, { pageNum: this.pageNo, pageSize: this.pageSize })
      if (this.getParams === null) {
        return params
      }
      return this.getParams(params)
    },
    processResult (res) {
      if (res.code === 200) {
        const { result } = res
        this.dataList = []
        this.dataList = this.dataList.concat(result)
      }
      this.finished = true
    }
  }
}
</script>

<style scoped lang="less">
  .van-cell {
    padding: 10px 32px;
  }
</style>
